export default __webpack_public_path__ + "342638ec4959cdb6a03f615365a98f3f.wav";